import { STATUS_MODEL } from "../../../../../enums/statusEnum";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */


export const MANAGE_RESERVATION_MODEL = {
    id: null,
    bookingWindowValue: null,
    bookingWindowEnabled: true,
    attendeesLimitsValue: null,
    attendeesLimitsEnabled: true,
    eventSettingFileDto: null,
    eventSettingMediaOptionDto: [],

    toUpdate: function () {
        return {
            id: this.id,
            bookingWindowValue: this.bookingWindowValue,
            bookingWindowEnabled: this.bookingWindowEnabled,
            attendeesLimitsValue: this.attendeesLimitsValue,
            attendeesLimitsEnabled: this.attendeesLimitsEnabled,
            eventSettingMediaOptionDto: this.eventSettingMediaOptionDto
        }
    },

    isValid: function () {
        // Validate required numeric/text fields
        const hasRequiredValues =
            this.bookingWindowValue !== null &&
            this.bookingWindowValue !== "" &&
            this.attendeesLimitsValue !== null &&
            this.attendeesLimitsValue !== "";

        if (!hasRequiredValues) return false;

        // Ensure notificationChannels is a valid array
        if (!Array.isArray(this.eventSettingMediaOptionDto)) return false;

        // there exists a valid statusId (11 = inactive, 12 = active)
        const allValid = this.eventSettingMediaOptionDto.every(channel =>
            channel.statusId === STATUS_MODEL.ACTIVE_COMPANY || STATUS_MODEL.IN_ACTIVE_COMPANY
        )

        return allValid;
    },
}


export const EVENT_TYPE = {
    REQUEST_SUBMITTED: { eventType: 1, trans: "request_submitted" },
    REQUEST_APPROVED: { eventType: 2, trans: "request_approved" },
    REQUEST_REJECTED: { eventType: 3, trans: "request_rejected" },
    HOLD_EXPIRING_SOON: { eventType: 4, trans: "hold_expiring_soon" },
    INVITES_SENT: { eventType: 5, trans: "invites_sent" },
    RESCHEDULED: { eventType: 6, trans: "rescheduled" },
    CANCELLED: { eventType: 7, trans: "cancelled" },
};


/**
 * Function to get the IDs of deleted files.
 * It compares the original list (from backend) with the current list (state),
 * ignoring any new files that have `id: null`.
 *
 * @param {Array} originalList - List of original files (item.eventSettingFileDto)
 * @param {Array} currentList - List of current files in the state (photoPickerFile.listFiles)
 * @returns {Array<string>} - Returns an array with the IDs of deleted files
 *
 * @example
 * const deletedFileIds = getDeletedFileIds(item.eventSettingFileDto, photoPickerFile.listFiles);
 */
export const getDeletedFileIds = (originalList = [], currentList = []) => {
    if (!Array.isArray(originalList) || !Array.isArray(currentList)) return [];

    // Keep only files that already existed (ignore new ones)
    const currentIds = new Set(
        currentList
            .map(file => file?.id)
            .filter(id => id && id !== null)
    );

    // Return only IDs from the original list that are no longer in current list
    return originalList
        .map(file => file?.id)
        .filter(id => id && !currentIds.has(id));
};

export const EVENT_INVITATION_MODEL = {
    eventId: null,
    visitors: [],
    employees: [],
    toRegister: function ({ userList, userTypeId, visitorType}) {
        let aux = userList.map(e => {
            let type = {};
            if(userTypeId === USER_TYPE_MODEL.VISITOR)
                type = {
                    visitorType: {
                        id: visitorType
                    }
                }
            return {
                id: e.id,
                ...type
            }
        })
        return {
            eventId: this.eventId,
            visitors: userTypeId === USER_TYPE_MODEL.VISITOR ? aux: [],
            employees: userTypeId === USER_TYPE_MODEL.VISITOR ? []: aux
        }
    }
}
